export interface OneTrustConsentData {
    adStorage: boolean
    analyticsStorage: boolean
    necessaryConsent: boolean
    performanceConsent: boolean
    functionalConsent: boolean
    targetingConsent: boolean
    socialMediaConsent: boolean
}

export const getOneTrustConsent = (): OneTrustConsentData => {
    const cookieGroups =
        (typeof window !== "undefined" &&
            window?.OnetrustActiveGroups?.split(",").filter((v: string) => v)) ||
        []
    return {
        necessaryConsent: true,
        adStorage: cookieGroups.includes("C0004"),
        analyticsStorage: cookieGroups.includes("C0002"),
        performanceConsent: cookieGroups.includes("C0002"),
        functionalConsent: cookieGroups.includes("C0003"),
        targetingConsent: cookieGroups.includes("C0004"),
        socialMediaConsent: cookieGroups.includes("C0005")
    }
}
